import React, { useState } from 'react';
import { Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import InputMask from 'react-input-mask';

const SpecialInputmask = ({ values = [], onChange, name, children, ...rest }) => {
    const [selectedValue, setSelectedValue] = useState(rest.value || '');
    const [radioVisible, setRadioVisible] = useState(false);

    const handleRadioChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);

        if (onChange) {
            onChange({ target: { value, name } });
        }
    };


    const nameRadio = 'name' + Math.random().toString(36).substring(7);

    return (
        <div>
            <InputMask
                onChange={onChange}
                onFocus={() => setRadioVisible(true)} // Appeler handleTextFieldFocus lorsque le TextField obtient le focus
                onBlur={() => setRadioVisible(false)} // Mettre à jour l'état lorsque le TextField perd le focus
                {...rest}
                value={rest.value}
            >
                {children}
            </InputMask>

            {values.length > 0 && <RadioGroup aria-label="gender" name={nameRadio} value={selectedValue} onChange={(e) => handleRadioChange(e)}
                className={radioVisible ? 'conteneurProfDoub visible' : 'conteneurProfDoub'}
            >
                {values.map((val, index) => (
                    <FormControlLabel key={index} value={val} control={<Radio />} label={`${val === '' ? 'Non renseigné' : val} (profil ${index + 1})`} />
                ))}
            </RadioGroup>}
        </div>
    );
};

export default SpecialInputmask;
